// Helpers for the pages an emailed link opens (invite, password reset,
// email verification). The token travels in the URL fragment so it never
// reaches a server log or a Referer header.

// Reads the token from "#token=XYZ". Returns '' when there is none.
export const readHashToken = (hash = window.location.hash) => {
  const raw = String(hash || '').replace(/^#/, '');
  if (!raw) return '';
  try {
    return new URLSearchParams(raw).get('token') || '';
  } catch (err) {
    return '';
  }
};

// Drops the fragment from the address bar once the token is in state, so it
// is not left in the browser history or copied along with the address.
export const clearHash = () => {
  if (!window.location.hash) return;
  window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
};

export const PASSWORD_HINT = 'At least 8 characters, with an uppercase letter, a lowercase letter and a number.';

// The first rule a password breaks, or '' when it meets all of them.
export const passwordProblem = (password) => {
  const value = String(password || '');
  if (value.length < 8) return 'Password must be at least 8 characters long';
  if (!/[A-Z]/.test(value)) return 'Password must contain at least one uppercase letter';
  if (!/[a-z]/.test(value)) return 'Password must contain at least one lowercase letter';
  if (!/[0-9]/.test(value)) return 'Password must contain at least one number';
  return '';
};

// The per-user invite action in user admin. Someone with a pending invite
// gets it again; anyone else has a password, so the same endpoint sends
// them a link to choose a new one.
export const inviteActionLabel = (user) => (user?.invited_at ? 'Resend invite' : 'Send password reset link');
